import devLog from './devLog';
/**
 * Secure storage utility.
 * Uses sessionStorage for temporary/sensitive data instead of localStorage.
 * localStorage is only used for persistent, non-sensitive data (deployment IDs, preferences).
 */

const PREFIX = 'ep_';

/**
 * P5 SECURITY: In-memory token store — no localStorage/sessionStorage for auth tokens.
 * httpOnly cookies are the primary auth mechanism. This is a Safari fallback only.
 */
let _inMemoryToken = null;

export const setSessionToken = (token) => {
  _inMemoryToken = token;
};

export const getSessionToken = () => {
  return _inMemoryToken;
};

export const clearSessionToken = () => {
  _inMemoryToken = null;
};

/**
 * Store a temporary value (cleared on tab close).
 * Use for: session tokens, streaming state, temporary auth flags.
 */
export const setTempItem = (key, value) => {
  try {
    sessionStorage.setItem(`${PREFIX}${key}`, typeof value === 'string' ? value : JSON.stringify(value));
  } catch (e) {
    devLog.warn('[SecureStorage] sessionStorage write failed:', e.message);
  }
};

export const getTempItem = (key) => {
  try {
    return sessionStorage.getItem(`${PREFIX}${key}`);
  } catch (e) {
    devLog.warn('[SecureStorage] sessionStorage read failed:', e.message);
    return null;
  }
};

export const removeTempItem = (key) => {
  try {
    sessionStorage.removeItem(`${PREFIX}${key}`);
  } catch (e) {
    devLog.warn('[SecureStorage] sessionStorage remove failed:', e.message);
  }
};

/**
 * Store a persistent value (survives tab close, for non-sensitive data).
 * Use for: deployment IDs, preferences, cached UI state.
 */
export const setPersistItem = (key, value) => {
  try {
    localStorage.setItem(`${PREFIX}${key}`, typeof value === 'string' ? value : JSON.stringify(value));
  } catch (e) {
    devLog.warn('[SecureStorage] localStorage write failed:', e.message);
  }
};

export const getPersistItem = (key) => {
  try {
    return localStorage.getItem(`${PREFIX}${key}`);
  } catch (e) {
    devLog.warn('[SecureStorage] localStorage read failed:', e.message);
    return null;
  }
};

export const removePersistItem = (key) => {
  try {
    localStorage.removeItem(`${PREFIX}${key}`);
  } catch (e) {
    devLog.warn('[SecureStorage] localStorage remove failed:', e.message);
  }
};
